<div>
  <div class="flex flex-row flex-nowrap justify-start">
    <button class="flex items-center mx-1" nz-button nzType="primary" (click)="addRow()">
      <i nz-icon nzType="plus"></i>
      <span>ROW</span>
    </button>
    <button class="flex items-center mx-1" nz-button nzType="primary" (click)="addRow(true)">
      <i nz-icon nzType="plus"></i>
      <span>HIDEABLE ROW</span>
    </button>
  </div>
  <nz-collapse class="mt-2 mb-4">
    <ng-container *ngFor="let row of rows.controls; let iRow = index">
      <nz-collapse-panel [nzHeader]="getCollapseTitle(iRow)">
        <div class="flex flex-row items-end gap-2">
          <om-input class="mr-4 pb-1" label="Titolo" [control]="row.get('titleCtrl')"></om-input>
          <om-select class="w-48 pb-1" [options]="typeFieldsOptions" [label]="'Campo'" [control]="row.get('typeFieldsCtrl')"></om-select>
          <!-- <button nz-button nzType="primary" [disabled]="limitedEditing" (click)="addField(iRow)"><i class="text-xl" nz-icon nzType="plus"></i></button>
          <button class="ml-auto" nz-button nzType="primary" nzDanger nz-popconfirm nzPopconfirmTitle="{{'POPCONFIRM.DELETE_MESSAGE' | translate}}"
            [disabled]="limitedEditing && row.get('formArray').length > 0" (nzOnConfirm)="removeRow(iRow)">
            <i class="text-xl" nz-icon nzType="delete"></i>
          </button> -->
          <button class="pb-1" nz-button nzType="primary" [disabled]="false" (click)="addField(iRow)"><i class="text-xl" nz-icon nzType="plus"></i></button>
          <!-- <om-checkbox class="pb-1" *ngIf="row.get('omissibleCtrl')" label="Occultabile" [control]="row.get('omissibleCtrl')"></om-checkbox> -->
          <button class="ml-auto pb-1" nz-button nzType="primary" nzDanger nz-popconfirm nzPopconfirmTitle="{{'POPCONFIRM.DELETE_MESSAGE' | translate}}"
            [disabled]="row.get('formArray').length > 0" (nzOnConfirm)="removeRow(iRow)">
            <i class="text-xl" nz-icon nzType="delete"></i>
          </button>
        </div>
        <ng-container *ngFor="let fieldForm of row.get('formArray').controls; let iField = index">          
          <form [formGroup]="fieldForm" *ngIf="fieldForm.get('omType').value !== 'HIDEABLE_SWITCH'">
            <div class="flex flex-col gap-2 mt-4 p-2 border-solid border-2 border-gray-200">
              <div class="flex flex-row gap-2">
                <span class="font-bold mr-auto">{{ fieldForm.get('omType').value }}</span>
                <button nz-button nzType="default" [disabled]="iRow === 0" (click)="moveField(iRow, iField, 'up')">
                  <i class="text-xl" nz-icon nzType="up"></i>
                </button>
                <button nz-button nzType="default" [disabled]="iRow === rows.length - 1" (click)="moveField(iRow, iField, 'down')">
                  <i class="text-xl" nz-icon nzType="down"></i>
                </button>
                <button nz-button nzType="default" [disabled]="iField === 0" (click)="moveField(iRow, iField, 'left')">
                  <i class="text-xl" nz-icon nzType="left"></i>
                </button>
                <button nz-button nzType="default" [disabled]="iField === row.get('formArray').length - 1" (click)="moveField(iRow, iField, 'right')">
                  <i class="text-xl" nz-icon nzType="right"></i>
                </button>
                <button nz-button nzType="primary" nzDanger nz-popconfirm nzPopconfirmTitle="{{'POPCONFIRM.DELETE_MESSAGE' | translate}}"
                  [disabled]="limitedEditing" (nzOnConfirm)="removeField(iRow, iField)">
                  <i class="text-xl" nz-icon nzType="delete"></i>
                </button>
              </div>
              <div class="grid grid-cols-3 gap-2 w-full mr-2">
                <om-input label="Key" [control]="fieldForm.get('key')"></om-input>
                <om-input label="Label" [control]="fieldForm.get('label')"></om-input>
                <om-input *ngIf="fieldForm.get('placeholder')" label="Placeholder" [control]="fieldForm.get('placeholder')"></om-input>
                <om-select label="Size" [options]="typeSizeOptions" [control]="fieldForm.get('size')"></om-select>
                <ng-container *ngIf="fieldForm.get('issueField')">
                    <issue-field-mention [wsForm]="fieldForm.get('issueField')"></issue-field-mention>
                </ng-container>
                <om-select *ngIf="fieldForm.get('dataSource')" [options]="dataSources" label="DataSource" [control]="fieldForm.get('dataSource')"></om-select>
                <om-input *ngIf="fieldForm.get('filter')" label="Filter" [control]="fieldForm.get('filter')"></om-input>
                <ng-container *ngIf="fieldForm.get('dataSource')?.value === 'QUERY'">
                  <om-select *ngIf="fieldForm.get('queryId')" label="queryId" [control]="fieldForm.get('queryId')" [options]="querySelectOptions$ | async"></om-select>
                  <om-input *ngIf="fieldForm.get('optionValue')" label="optionValue" [control]="fieldForm.get('optionValue')"></om-input>
                  <om-input *ngIf="fieldForm.get('optionLabel')" label="optionLabel" [control]="fieldForm.get('optionLabel')"></om-input>
                </ng-container>
                <div *ngIf="fieldForm.get('options')" class="flex flex-col col-span-2 bg-gray-100 p-2">
                  <button class="flex items-center w-32" nz-button nzType="primary" (click)="addOption(iRow, iField)">
                    <i nz-icon nzType="plus"></i>
                    <span>OPTION</span>
                  </button>
                  <nz-empty *ngIf="fieldForm.get('options').length === 0"></nz-empty>
                  <div *ngFor="let option of fieldForm.get('options').controls; let iOption = index">
                    <div class="flex flex-row h-20 gap-2">
                      <om-input class="flex-grow" label="Value" [control]="option.get('value')"></om-input>
                      <om-input class="flex-grow" label="Label" [control]="option.get('label')"></om-input>
                      <button class="flex-grow-0 self-end mb-4" nz-button nzType="default" nzDanger (click)="removeOption(iRow, iField, iOption)">
                        <i class="text-xl" nz-icon nzType="delete"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row gap-2">
                  <om-checkbox *ngIf="fieldForm.get('required')" label="Required" [control]="fieldForm.get('required')"></om-checkbox>
                  <om-checkbox *ngIf="fieldForm.get('multiple')" label="Multiple" [disabled]="limitedEditing" [control]="fieldForm.get('multiple')"></om-checkbox>
                  <om-checkbox *ngIf="fieldForm.get('searchable')" label="Searchable" [control]="fieldForm.get('searchable')" [disabled]="fieldForm.get('searchable').value || false"></om-checkbox>
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </nz-collapse-panel>
    </ng-container>
  </nz-collapse>
  <om-debug title="Fields" [data]="fieldsObj"></om-debug>
</div>
